export default function SuccessModal({ onClose }) {
  return (
    <div className="contact-modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title">
      <button type="button" className="contact-modal__backdrop" onClick={onClose} aria-label="Close dialog" />
      <div className="contact-modal__panel">
        <h2 id="contact-modal-title" className="contact-modal__title">Service Request Sent</h2>
        <p className="contact-modal__text">Someone will contact you shortly.</p>
        <button type="button" className="page-cta-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
